import { useEffect, useRef } from "react";
import cable from "../lib/cable";
import { useDeviceStore } from "../lib/store";

export function useDeviceChannel(deviceId) {
  const subscriptionRef = useRef(null);
  const updateLiveReading = useDeviceStore((s) => s.updateLiveReading);

  useEffect(() => {
    if (!deviceId) return;

    subscriptionRef.current = cable.subscriptions.create(
      { channel: "DeviceChannel", device_id: deviceId },
      {
        received(data) {
          if (data.type === "new_reading") {
            updateLiveReading(deviceId, data.reading);
          }
        },
      }
    );

    return () => {
      subscriptionRef.current?.unsubscribe();
    };
  }, [deviceId, updateLiveReading]);
}
